(function(){
    angular
        .module('app')
        .directive('latinize', latinize);

        latinize.$inject = ['$timeout'];
        function latinize($timeout){
            return {
	            require: 'ngModel',
	            link: function(scope, element, attrs, modelCtrl) {
	            	console.log('hola');
      				modelCtrl.$validators.latinize = function(modelValue, inputValue) {
						console.log('hola');
			        	var regexp = /[A-z\u00C0-\u00ff]+/g;
			            return regexp.test(inputValue);
			        }
				}
        	}
        }
})();